module.exports = __webpack_public_path__ + "static/media/entranceM.94caf76c.jpg";